import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const JSM_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const JSM_DEFAULT_UNIT_COUNT = 75;

export const JSM_MIN_ENTERPRISE_USER_COUNT = 201;

export const jsmOfferingSkus = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
} as const;

export const jsmOfferingSkusArray = Object.values(jsmOfferingSkus);

export const jsmPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: jsmOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 20_000
    },
    {
        planName: "Standard",
        offeringSku: jsmOfferingSkus.standard,
        recommendationLimit: 3,
        signupLimit: 20_000
    },
    {
        planName: "Premium",
        offeringSku: jsmOfferingSkus.premium,
        recommendationLimit: 50,
        signupLimit: 20_000
    },
    {
        planName: "Enterprise",
        offeringSku: jsmOfferingSkus.enterprise,
        recommendationLimit: 250,
        signupLimit: 20_000
    }
];

export const jsmBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
